import React from 'react'
import JoanInRoom from './inRoom/router'

const App = (): JSX.Element => {
  return <JoanInRoom />
}

export default App
